// Angular
import {Injectable} from '@angular/core';
import {CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot, Router} from '@angular/router';
// Model
import {AUTHACTIONS, AUTHROLE} from '../model/role.model';
import {UserContextModel} from '../auth/user-context.model';
import {UserContextState} from '../auth/user-context.state';
// Service
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {RoleService} from '../service/role.services';
import { AppService } from '../service/app.service';
import { PermissionService } from '../service/permission.service';
// Store
import {Store} from '@ngxs/store';
import {Observable, of} from 'rxjs';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
	user$: Observable<UserContextModel> = this.store.select(UserContextState.getUserContext);

	private currentUser: UserContextModel;

	constructor(
		private oidcSecurityService: OidcSecurityService,
		private roleService: RoleService,
		private store: Store,
		private appService: AppService,
		private permissionService: PermissionService,
		private router: Router
	) {
		this.user$.subscribe((user: UserContextModel) => {
			this.currentUser = user;
		});
	}

	/**
	 * Can activate validation.
	 * NOTE: this only works for when the user access withut any URL, leave as it is
	 *
	 * @param route: ActivatedRouteSnapshot
	 * @param state: RouterStateSnapshot
	 */
	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		const token = this.store.selectSnapshot(UserContextState.token);
		const permissions = (this.store.selectSnapshot(UserContextState.permission) || [])
								.filter((r: any) => r !== AUTHROLE.NOTALLOWED);

		if (this.oidcSecurityService.isAuthenticated()) {
			const skip = this.roleService.skipCanActivateGuard(route.url[0], this.currentUser.role);
			if (skip) {
				return of(true);
			} else {
				setTimeout(() => {
					return of(this.roleService.setPathByRole(state));
				}, 1000);
			}
			return of(false);
		} else if (token && permissions.length) {
			const path = this.appService.getDefaultPathByPermissions(permissions);

			if (path !== '') {
				this.router.navigate([`${path}`]).catch((e) => console.warn(e));
				return of(true);
			} else {
				console.groupCollapsed('AUTH.GUARD');
				console.log('token but not authorized and no url');
				console.log(this.oidcSecurityService.getAccessToken());
				console.log(this.oidcSecurityService.getUserData());
				console.groupEnd();
				this.roleService.unAuthSetValues(AUTHACTIONS.LOGIN);
				return of(false);
			}
		} else {
			console.groupCollapsed('AUTH.GUARD');
			console.log('completly unauthorized');
			console.log(this.oidcSecurityService.getAccessToken());
			console.log(this.oidcSecurityService.getUserData());
			console.groupEnd();
			this.roleService.unAuthSetValues(AUTHACTIONS.LOGIN);
			return of(false);
		}
	}
}
